import {dateFormatter} from "@sfs/utils/formatters";
import {HideableContent} from "@sfs/components/HideableContent";
import {useTranslation} from "react-i18next";

type BuildInfo = {
  version: string;
  hash: string;
  branch: string;
  buildDate?: string;
};

export const getBuildInfo = (): BuildInfo => {
  return {
    version: process.env.REACT_APP_GIT_VERSION!,
    hash: process.env.REACT_APP_GIT_HASH!,
    branch: process.env.REACT_APP_GIT_BRANCH!,
    buildDate: process.env.REACT_APP_BUILD_DATE,
  };
};

export const logBuildInfo = () => {
  const {version, hash, branch, buildDate} = getBuildInfo();
  console.groupCollapsed("Build info");
  console.log("Version:   ", version);
  console.log("Hash:      ", hash);
  console.log("Branch:    ", branch);
  buildDate &&
    console.log("Build date:", dateFormatter.longDateTime(buildDate, {displayInTimeZone: "user"}));
  console.groupEnd();
};

export const NoeVersionInfo = () => {
  const {t} = useTranslation();
  const {version, hash, branch, buildDate} = getBuildInfo();

  return (
    <HideableContent buttonOpenTitle={t("common:noeVersion")}>
      <ul style={{margin: 0}}>
        <li>
          <strong>Version:</strong> {version}
        </li>
        <li>
          <strong>Hash:</strong> {hash}
        </li>
        <li>
          <strong>Branch:</strong> {branch}
        </li>
        {buildDate && (
          <li>
            <strong>Build date:</strong>{" "}
            {dateFormatter.longDateTime(buildDate, {displayInTimeZone: "user"})}
          </li>
        )}
      </ul>
    </HideableContent>
  );
};
